<template>
  <div id="student-work-modal"
       class="student-work-modal"
       :class="{'is-visible': isVisible}">

    <div class="student-work-modal__inner">
      <figure>
        <img :alt="title" :src="thumbUrl"/>
        <figcaption>{{ title }}</figcaption>
      </figure>
    </div>

    <div class="student-work-modal__close">
      <button @click="hideModal">X</button>
    </div>

  </div>
</template>

<script>
export default {
  name: 'StudentWorkModal',

  props: {
    isVisible: Boolean,
    work: Object
  },

  computed: {
    imageUrl () {
      return this.work.image
    },

    title () {
      return this.work.title
    },

    thumbUrl () {
      return this.work.thumb
    }
  },

  methods: {
    hideModal () {
      this.$emit('close-student-work-modal')
    }
  }
}

</script>
